import FeatureGates from '@atlaskit/feature-gate-js-client';
import { type DefaultMessagesResponse, createPlacement } from '@post-office/placement-common-v2';
import { usePlacementApi } from '@post-office/use-placement-api';
// @ts-expect-error: 'React' is declared but its value is never read
// React import required to render in Jira SSR
import React, { type PropsWithChildren } from 'react';

export const { createFrontend, createBackend } = createPlacement({
	placementId: 'jira-filter-refinement-filter-button',
	options: {
		choreographer: {
			isDefaultEnabled: false,
		},
	},
});

type PlacementFrontendProps = {
	view?: 'backlog' | 'list';
} & PropsWithChildren;

export const PlacementFrontend = createFrontend<PlacementFrontendProps>(
	(Messages) =>
		({ children, view }) => {
			const { data, error, isLoading } = usePlacementApi<DefaultMessagesResponse>(
				'/',
				view && FeatureGates.checkGate('changeboarding-filter-refinement-in-nin')
					? {
							queryParams: {
								view,
							},
						}
					: undefined,
			);

			if (!children) {
				return null;
			}

			if (error || isLoading || data.messages.length === 0) {
				return <>{children}</>;
			}

			const [message] = data.messages;

			return <Messages.render {...message}>{children}</Messages.render>;
		},
);

export const PlacementBackend = createBackend();
